import { Component, OnInit, Input, SimpleChanges, ViewChild, ChangeDetectorRef, OnChanges, signal, WritableSignal, model, ModelSignal, ChangeDetectionStrategy } from '@angular/core';
import { PromoCodeService } from 'src/app/api/promoCodes.service';
import { PromoCodes } from 'src/app/api';
import { IconService } from 'src/app/ui/icon.service';
import { PromoFormComponent } from '../promo-form/promo-form.component';
import { Table } from 'primeng/table';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';

@Component({
  selector: 'app-promo-codes',
  templateUrl: './promo-codes.component.html',
  styleUrls: ['./promo-codes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PromoCodesComponent implements OnInit {
  protected inputData: any = {};


  promoCodes: WritableSignal<PromoCodes[]> = signal([]);

  isEditing = false;
  selectedPromo: any = null;

  @Input() set promo(value: PromoCodes[]) {
    this.inputData['promo'] = value
  }

  get promo(): PromoCodes[] {
    return this.inputData['promo']
  }

  @Input() set promoId(value: number) {
    this.inputData['promoId'] = value
  }

  showForm: ModelSignal<boolean> = model(false);


  @ViewChild(PromoFormComponent) promoForm!: PromoFormComponent
  @ViewChild('dt2') dt2!: Table;

  splitterPanelSizes = signal<number[]>([99, 1])


  truncateCount = 35

  errors: WritableSignal<string[]> = signal([])
  errorsVisible: ModelSignal<boolean> = model(false)

  editedPromo: WritableSignal<PromoCodes | undefined> = signal(undefined)

  filterTableGlobal(e: any) {
    this.dt2.filterGlobal(e.target.value, 'contains');
  }

  constructor(
    private dataPadService: DataPadService,
    private promoCodeService: PromoCodeService,
    public icons: IconService,
    private cdRef: ChangeDetectorRef,
  ) { }


  newPromoCode: object = {}
  displayModal: boolean = false;


  editPromo(promo: PromoCodes) {
    this.editedPromo.set(promo);  
    this.dataPadService.showPanel({
      panelName: 'promoForm',
      inputData: { editPromo: promo }
    });
  }

  openAddPromoForm(): void {
    this.promoForm.resetForm()
    this.editedPromo.set(undefined)
    this.showForm.set(true)
  }


  onRowEditInit(promo: PromoCodes) {
    this.editedPromo.set(promo)
    this.showForm.set(true)

  }



  ngOnInit(): void {
    this.loadPromoCodes();

    this.promoCodeService.promoUpdated$.subscribe(() => {
      this.loadPromoCodes();
    });

  }

  loadPromoCodes(): void {
    this.promoCodeService.getPromoCodes().subscribe((data) => {
      this.promoCodes.set(data.sort((a, b) => (b?.promoStart?.valueOf() ?? 0) - (a?.promoStart?.valueOf() ?? 0)))

    });
  }

  addPromoToTable(promoCode: PromoCodes) {
    const currentPromoCodes = this.promoCodes();
    this.promoCodes.set([...currentPromoCodes, promoCode]);
  }

  updatePromoInTable(promoCode: PromoCodes) {
    const currentPromoCodes = this.promoCodes();
    const updatedPromoCodes = currentPromoCodes.map(p => p.id === promoCode.id ? promoCode : p);
    this.promoCodes.set([...updatedPromoCodes]); 
  }


  promoFormSubmitted(event: { isEdit: boolean; promoCode: PromoCodes }) {

    if (event.isEdit) {
      this.updatePromoInTable(event.promoCode);
    } else {
      this.addPromoToTable(event.promoCode);
    }
    this.showForm.set(false);
    this.editedPromo.set(undefined);

  }

  cancelEdit() {
    this.isEditing = false;
    this.selectedPromo = null;
  }

}


